import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ message = "Loading...", showLoginPrompt = false }) => {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        {/* Animated Logo */}
        <div className="loading-logo">
          <div className="logo-circle">
            <span className="logo-text">CAPS+</span>
          </div>
          <div className="loading-rings">
            <div className="ring ring-1"></div>
            <div className="ring ring-2"></div>
            <div className="ring ring-3"></div>
          </div>
        </div>

        {/* Loading Animation */}
        <div className="loading-animation">
          <div className="dot-spinner">
            <div className="dot dot-1"></div>
            <div className="dot dot-2"></div>
            <div className="dot dot-3"></div>
            <div className="dot dot-4"></div>
          </div>
        </div>

        {/* Loading Message */}
        <div className="loading-message">
          <h2>{message}</h2>
          {showLoginPrompt && (
            <p className="loading-subtitle">
              Please wait while we redirect you to login...
            </p>
          )}
        </div>

        {/* Progress Indicator */}
        <div className="loading-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>

        {/* Background Animation */}
        <div className="background-animation">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
          <div className="floating-shape shape-4"></div>
          <div className="floating-shape shape-5"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;